export default __webpack_public_path__ + "static/media/7.a57fb9c2.jpg";